import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "booking-v4-header",
  "data-testid": "booking-v4-header",
  class: "flex items-center justify-between gap-4 px-3 py-1.5 border-b border-gray-lp-1400"
}
const _hoisted_2 = { class: "flex items-center gap-2 border border-gray-lp-1400 rounded-full p-1" }
const _hoisted_3 = {
  key: 0,
  class: "w-2.5 h-2.5 rounded-full bg-green-lp-1800 p-0.5"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-green-lp-100" }, null, -1)
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = { class: "relative inline-block" }
const _hoisted_7 = {
  key: 0,
  class: "absolute mt-2 right-0 z-40 py-2 bg-white rounded-xl shadow-md border border-gray-lp-1600",
  style: {"width":"180px"}
}
const _hoisted_8 = { "data-testid": "booking-v4-header-booking-history-trigger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ListHistorySuccessBooking = _resolveComponent("ListHistorySuccessBooking")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createBlock("button", {
          key: tab.value,
          "data-testid": `booking-v4-header-tab-${tab.value}`,
          class: ["flex items-center gap-2 rounded-full h-8 px-4 text-xs font-semibold transition-colors", 
          tab.value === _ctx.activeTab
            ? 'bg-red-lp-2400 text-white'
            : 'text-gray-lp-3005'
        ],
          onClick: ($event: any) => (_ctx.onTabClick(tab.value))
        }, [
          (tab.value === _ctx.activeTab)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(tab.label), 1)
        ], 10, ["data-testid", "onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_5, [
      _withDirectives(_createVNode("div", _hoisted_6, [
        _createVNode("button", {
          "data-testid": "booking-v4-header-receipt-format-selector",
          class: "flex items-center gap-2 rounded-full h-8 px-3 text-xs font-semibold text-black-lp-100 border border-gray-lp-1600",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleReceiptFormatMenu && _ctx.toggleReceiptFormatMenu(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.activeReceiptFormatLabel) + " ", 1),
          _createVNode(_component_Icons, {
            name: "chevron-down",
            class: "w-3"
          })
        ]),
        (_ctx.showReceiptFormatMenu)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receiptFormatOptions, (option, index) => {
                return (_openBlock(), _createBlock("button", {
                  key: option.value,
                  "data-testid": 
              `booking-v4-header-receipt-format-option-${option.value}`
            ,
                  class: ["flex items-center w-full px-4 py-2 text-xs text-left gap-2.5", 
              [option.value === _ctx.receiptFormat
                ? 'font-semibold text-red-lp-2400'
                : 'text-black-lp-100',
                { 'border-b border-gray-lp-1600': index !== (_ctx.receiptFormatOptions.length-1)}
              ]
            ],
                  onClick: ($event: any) => (_ctx.onReceiptFormatClick(option.value))
                }, [
                  _createVNode(_component_Icons, {
                    name: "printer",
                    class: ["w-6", [
                {'text-gray-lp-3005': option.value !== _ctx.receiptFormat }
              ]]
                  }, null, 8, ["class"]),
                  _createTextVNode(" " + _toDisplayString(option.label), 1)
                ], 10, ["data-testid", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_directive_click_outside, _ctx.closeReceiptFormatMenu]
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_ListHistorySuccessBooking, { ref: "listHistorySuccessBooking" }, null, 512)
      ])
    ])
  ]))
}